import { j as t } from "./jsx-runtime-C5mzlN2N.js";
import { useEffect as $ } from "react";
import n, { keyframes as h } from "styled-components";
import "./components/Theme/themes.es.js";
import "./palettes-Bw24w7AF.js";
import { getSpacings as i, getPaletteBorder as y, getRadii as b, getPaletteBackground as j, getEffects as v, getBreakpointMediaQuery as d, getZIndexes as w } from "./components/Theme/utils.es.js";
import "./CssBaseline-Bp4jdUgb.js";
import { I } from "./IconButton-g0G4rvcV.js";
import { I as k } from "./CheckIcon-XCAywhAi.js";
import "./components/Icon/countryVariants.es.js";
import { F as C } from "./FileIcon-Co5mezSH.js";
import "./components/FeaturedIcon/constants.es.js";
import "./styles-DaQVIHg4.js";
import { T } from "./Typography-CGn3dGWy.js";
import { notificationItemAnimationKeyframes as z, notificationListStyles as A } from "./components/Notification/styles.es.js";
import { STATE_VARIANT_MAPPER as N } from "./components/Notification/constants.es.js";
const B = n.div`
  display: flex;
  position: relative;
  width: 400px;
  box-sizing: border-box;
  
  animation-timing-function: ease-in-out;
  animation-duration: 300ms;
  
  animation-name: ${(o) => z[o.$position]};
  
  padding: ${i("xl")};
  border: 1px solid ${y("primary")};
  border-radius: ${b("xl")};
  background: ${j("primary.default")};
  box-shadow: ${v("shadows.lg")};
  
  ${d("max", "lg")} {
    width: 100%;
  }
`, E = n.div`
  display: flex;
  flex-direction: row;
  
  padding-right: ${i("4xl")};
  gap: ${i("xl")};
  
  ${d("max", "lg")} {
    flex-direction: column;
  }
`, P = n.div`
  display: flex;
  flex-direction: column;
  
  gap: ${i("lg")};
`, S = n.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  
  gap: ${i("xs")};
`, R = n(I)`
  position: absolute;
  top: 8px;
  right: 8px;
`, c = n(T)`
  word-break: break-word;
`, ii = (o) => {
  const {
    title: r,
    message: a,
    variant: e,
    className: g,
    position: x = "bottom-left",
    children: f,
    autoCloseDuration: l,
    createdAt: u = Date.now,
    onClose: s,
    actions: m
  } = o;
  return $(() => {
    let p;
    return s && l && (p = setTimeout(() => {
      s();
    }, l)), () => {
      clearTimeout(p);
    };
  }, [u]), /* @__PURE__ */ t.jsxs(
    B,
    {
      $position: x,
      className: g,
      children: [
        /* @__PURE__ */ t.jsx(
          R,
          {
            variant: "ghost",
            color: "gray",
            onClick: s,
            children: /* @__PURE__ */ t.jsx(
              k,
              {
                variant: "close"
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsxs(E, { children: [
          e && /* @__PURE__ */ t.jsx(
            C,
            {
              size: "sm",
              variant: "outlined",
              color: e,
              iconProps: {
                variant: N[e]
              }
            }
          ),
          /* @__PURE__ */ t.jsxs(P, { children: [
            /* @__PURE__ */ t.jsxs(S, { children: [
              /* @__PURE__ */ t.jsx(
                c,
                {
                  size: "sm",
                  weight: "semibold",
                  children: r
                }
              ),
              a && /* @__PURE__ */ t.jsx(
                c,
                {
                  size: "sm",
                  weight: "regular",
                  children: a
                }
              ),
              m && m
            ] }),
            f
          ] })
        ] })
      ]
    }
  );
}, F = h`
  from {
    opacity: 0;
  }
  
  to {
    opacity: 1;
  }
`, M = n.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  position: fixed;
  
  animation: ease-in-out ${F} 150ms;
  
  gap: ${i("3xl")};
  padding: ${i("3xl")};
  z-index: ${w("notification")};
  
  ${d("max", "lg")} {
    width: 100%;
    background: linear-gradient(357deg, rgba(0, 0, 0, 0.10) 2.75%, rgba(0, 0, 0, 0.00) 92.77%);
    margin: 0;

    gap: ${i("xl")};
    padding-top: ${i("xl")};
    padding-bottom: ${i("xl")};
    
    padding-left: ${i("md")};
    padding-right: ${i("md")};
  };
  
  ${(o) => A[o.$position]};
`, ti = (o) => {
  const {
    children: r,
    className: a,
    position: e = "bottom-left"
  } = o;
  return /* @__PURE__ */ t.jsx(
    M,
    {
      $position: e,
      className: a,
      children: r
    }
  );
};
export {
  ti as N,
  ii as a
};
